import { render } from "./choice.vue?vue&type=template&id=d6629ff8&scoped=true"
import script from "./choice.vue?vue&type=script&lang=js"
export * from "./choice.vue?vue&type=script&lang=js"

import "./choice.vue?vue&type=style&index=0&id=d6629ff8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6629ff8"]])

export default __exports__